import {
  formatCurrency,
  formatNumber,
  formatPercent,
} from "pages/analytics/components/analyticsFormatters";
import { attributionConversionPercent } from "../utils/attributionDashboardUtils";

export default function AttributionDrilldownTable({ rows }) {
  if (!rows.length) {
    return null;
  }

  const totals = rows.reduce(
    (acc, row) => ({
      contacts: acc.contacts + row.contacts,
      sales: acc.sales + row.sales,
      revenue: acc.revenue + row.revenue,
    }),
    { contacts: 0, sales: 0, revenue: 0 }
  );

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            {["Source", "Campaign", "Account", "Contacts", "Sales", "Revenue", "Conversion %"].map(
              (col) => (
                <th
                  key={col}
                  className={`px-3 py-2 text-xs font-medium text-gray-500 uppercase ${
                    col === "Source" || col === "Campaign" || col === "Account"
                      ? "text-left"
                      : "text-right"
                  }`}
                >
                  {col}
                </th>
              )
            )}
          </tr>
        </thead>
        <tbody className="divide-y divide-gray-100">
          {rows.map((row, i) => (
            <tr key={`${row.source}-${row.campaign}-${row.account}-${i}`} className="hover:bg-gray-50">
              <td className="px-3 py-2.5 text-sm text-gray-900">{row.source}</td>
              <td className="px-3 py-2.5 text-sm text-gray-900">{row.campaign}</td>
              <td className="px-3 py-2.5 text-sm text-gray-900">{row.account}</td>
              <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
                {formatNumber(row.contacts)}
              </td>
              <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
                {formatNumber(row.sales)}
              </td>
              <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
                {formatCurrency(row.revenue)}
              </td>
              <td className="px-3 py-2.5 text-sm text-gray-600 text-right">
                {formatPercent(row.conversion)}
              </td>
            </tr>
          ))}
        </tbody>
        <tfoot>
          <tr className="bg-gray-50 font-medium">
            <td colSpan={3} className="px-3 py-2.5 text-sm text-gray-700">
              Total
            </td>
            <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
              {formatNumber(totals.contacts)}
            </td>
            <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
              {formatNumber(totals.sales)}
            </td>
            <td className="px-3 py-2.5 text-sm text-gray-900 text-right">
              {formatCurrency(totals.revenue)}
            </td>
            <td className="px-3 py-2.5 text-sm text-gray-600 text-right">
              {formatPercent(attributionConversionPercent(totals.contacts, totals.sales))}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
